import React from "react";
import { useMantineTheme } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import dayjs from 'dayjs';

const PickerDate = ({
    stateDate = new Date(),
    fnSetDate,
    stateLabel = '',
    statePlaceHolder = '',
    stateFormat = "DD MMMM YYYY",
    stateClearable = false,
    stateReadOnly = false,
    stateDisabled = false,
    stateWithAsterisk = false,
    stateDescription = '',
    stateError = '',
    stateVariant = 'default', /* default | filled | unstyled */
    stateRadius = 'sm',
    stateSize = 'sm',
    stateIcon = <IconCalendar size="1.25rem" stroke={1.5} />,
    stateSX = {},
    stateIconSX = {},
    stateStylesInput = {},
    stateStylesRoot = {},
    stateMT = '0',
    stateMB = '0',
    stateDropdownType = 'popover', /* popover | modal */

    stateMinDate = {},
}) => {

    const theme = useMantineTheme();
    const today = dayjs().startOf('day').toDate();

    const renderDay = (date) => {
        const isToday = dayjs(date).isSame(today, 'day');

        return (
            <div
                style={{
                    backgroundColor: isToday ? (theme.colorScheme === 'light' ? theme.colors.orange[6] : theme.colors.orange[7]) : 'transparent',
                    color: isToday ? (theme.colorScheme === 'light' ? '#fff' : '#fff') : 'default',
                    borderRadius: '50%',
                    padding: '5px',
                }}
            >
                {date.getDate()}
            </div>
        );
    };

    return (
        <DatePickerInput
            icon={stateIcon}
            label={stateLabel}
            placeholder={statePlaceHolder}
            valueFormat={stateFormat}
            value={stateDate}
            onChange={fnSetDate}
            dropdownType={stateDropdownType}
            clearable={stateClearable}
            readOnly={stateReadOnly}
            disabled={stateDisabled}
            withAsterisk={stateWithAsterisk}
            description={stateDescription}
            error={stateError}
            variant={stateVariant}
            radius={stateRadius}
            size={stateSize}
            sx={stateSX}
            mt={stateMT}
            mb={stateMB}

            styles={() => ({
                root: stateStylesRoot,
                icon: stateIconSX,
                input: stateStylesInput,
            })}

            renderDay={renderDay}

            popoverProps={{ zIndex: 1001 }}

            minDate={stateMinDate}
        />
    )
}

export default PickerDate;